// extracted by mini-css-extract-plugin
export default {"statsOffer":"z489q3s6OkGGLn_TaB8c","row":"zRjlqN5cXS6VXH8FMJCU","extraContent":"R1dW3rYguwjkgfePXD0V"};